import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-parameter-audit",
  "use": "icon-parameter-audit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-parameter-audit\"><defs><style type=\"text/css\"></style></defs><path d=\"M1017.6 966.4l-192-192c32-38.4 51.2-89.6 51.2-147.2 0-134.4-108.8-249.6-249.6-249.6s-249.6 121.6-249.6 256 108.8 249.6 249.6 249.6c57.6 0 108.8-19.2 153.6-57.6l192 192c6.4 6.4 12.8 6.4 25.6 6.4s19.2 0 25.6-6.4c0-12.8 0-38.4-6.4-51.2z m-576-332.8C441.6 531.2 524.8 448 627.2 448c102.4 0 185.6 83.2 185.6 185.6s-83.2 185.6-185.6 185.6c-102.4 0-185.6-83.2-185.6-185.6z\" fill=\"#ffffff\" p-id=\"5703\" /><path d=\"M864 0H339.2c-6.4 0-6.4 6.4-12.8 6.4l-320 320s-6.4 6.4-6.4 12.8v652.8c0 19.2 12.8 32 32 32h448c19.2 0 32-12.8 32-32s-12.8-32-32-32H64V384h288c19.2 0 32-12.8 32-32V64h448v288c0 19.2 12.8 32 32 32s32-12.8 32-32v-320c0-19.2-12.8-32-32-32zM108.8 320L320 108.8V320H108.8z\" fill=\"#ffffff\" p-id=\"5704\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/parameter-audit.svg
// module id = SFvy
// module chunks = 102